import { useState, useEffect } from 'react'
import type { DropdownOptions, PurposeOption } from '@shared/types'
import { useApi } from '../contexts/ApiContext'

const FALLBACK_INDUSTRIES: string[] = [
  'Banking & Financial Services', 'Insurance', 'Capital Markets',
  'Retail & Consumer Goods', 'Manufacturing', 'Energy & Utilities',
  'Healthcare & Life Sciences', 'Pharmaceutical', 'Telecommunications',
  'Technology', 'Media & Entertainment', 'Government & Public Services',
  'Transportation & Logistics', 'Chemicals', 'Real Estate',
]

const FALLBACK_PURPOSE_OPTIONS: PurposeOption[] = [
  {
    value: 'pursuit',
    label: 'Pursuit, will tag to MMS Campaign Human+Machine Workforce Strategy - 00124892 when an opp is opened',
    requiresMmsId: true,
    defaultMmsId: '00124892',
  },
  {
    value: 'capability-test',
    label: 'This is a capability test only',
    requiresMmsId: false,
  },
  {
    value: 'existing-opp',
    label: 'I have an existing MMS OppID',
    requiresMmsId: true,
  },
]

const FALLBACK: DropdownOptions = {
  industries: FALLBACK_INDUSTRIES,
  purposeOptions: FALLBACK_PURPOSE_OPTIONS,
}

/**
 * Fetches dropdown option lists (industries, purpose options) from the verbiage
 * table in Cosmos DB via the /api/config/dropdown-options endpoint. Renders
 * immediately with fallback values while the request is in flight so the page
 * is never blank. On error the fallback values remain.
 */
export function useDropdownOptions(): DropdownOptions {
  const api = useApi()
  const [options, setOptions] = useState<DropdownOptions>(FALLBACK)

  useEffect(() => {
    api.getDropdownOptions().then((data) => {
      setOptions({
        ...data,
        purposeOptions: data.purposeOptions.map((opt) => ({
          ...(FALLBACK_PURPOSE_OPTIONS.find((f) => f.value === opt.value) ?? {}),
          ...opt,
        })),
      })
    }).catch(() => {})
  }, [api])

  return options
}
